import ApplicationSerializer from 'lumen/serializers/application';

export default class TransactionMappingItemSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey('transaction-mapping/item');
  }
}
